/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { StepScheduleDelayDelayType } from './stepScheduleDelayDelayType';

/**
 * Wait ``delay_value`` units (weekdays / business days / weeks /
 * months), optionally at a specific time of day, before
 * executing (auto-email) or before the task's due date (tasks).
 *
 * ``weeks`` / ``months`` are calendar offsets; ``weekdays`` /
 * ``business_days`` skip non-sending days. The bounds cover every unit
 * (months ≤ 24, weeks ≤ 52 both fit comfortably under 365).
 */
export interface StepScheduleDelay {
  mode: 'delay';
  /**
     * @minimum 1
     * @maximum 365
     */
  delay_value: number;
  delay_type: StepScheduleDelayDelayType;
  at_time?: string | null;
}
